var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoursePacedDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "live-stream 1",
    clipPath: "url(#clip0_2631_1092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1168 2.54057H8.61912L10.149 1.15467C10.3274 0.993263 10.3102 0.745047 10.1114 0.600219C9.91259 0.45539 9.60682 0.46935 9.42841 0.630319L7.67226 2.22082C7.32511 2.53534 6.67381 2.53534 6.32666 2.22082L4.57105 0.630755C4.39211 0.469786 4.08741 0.456263 3.88805 0.600655C3.68922 0.745047 3.67256 0.993263 3.85043 1.1551L5.38034 2.54101H2.88315C1.43116 2.54101 0.25 3.49985 0.25 4.67854V11.3625C0.25 12.5412 1.43116 13.5 2.88315 13.5H11.1168C12.5688 13.5 13.75 12.5412 13.75 11.3625V4.67854C13.75 3.49985 12.5688 2.54057 11.1168 2.54057ZM12.7827 11.3625C12.7827 12.108 12.0352 12.7148 11.1168 12.7148H2.88315C1.96477 12.7148 1.21728 12.108 1.21728 11.3625V4.67854C1.21728 3.93302 1.96477 3.32623 2.88315 3.32623H11.1168C12.0352 3.32623 12.7827 3.93302 12.7827 4.67854V11.3625Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.10324 6.92346L7.16297 5.7425C6.69392 5.45737 6.08625 5.42055 5.57656 5.64866C5.06634 5.87587 4.75 6.32445 4.75 6.81883V9.18119C4.75 9.67603 5.06634 10.1246 5.57604 10.3514C5.79857 10.4511 6.04039 10.5 6.28064 10.5C6.59073 10.5 6.89874 10.4183 7.16297 10.258L9.10272 9.07657C9.50766 8.83005 9.75 8.42772 9.75 8.00069C9.75052 7.57366 9.5087 7.17043 9.10324 6.92346ZM8.56176 8.41694L6.622 9.59834C6.43803 9.71105 6.20925 9.72362 6.00808 9.63472C5.80795 9.54536 5.68861 9.37607 5.68861 9.18164V6.81928C5.68861 6.62485 5.80795 6.45557 6.0086 6.36666C6.09615 6.32714 6.18944 6.30784 6.28221 6.30784C6.40103 6.30784 6.51881 6.33972 6.622 6.40303L8.56228 7.58399C8.72175 7.68098 8.81243 7.83275 8.81243 8.00069C8.81243 8.16863 8.72123 8.3204 8.56176 8.41694Z",
    fill: "#E4E4E4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2631_1092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePacedDarkIcon);
export default __webpack_public_path__ + "static/media/course-paced-dark-icon.a83c60dcd607b872a41b5c4b19061f9f.svg";
export { ForwardRef as ReactComponent };